module.exports = __webpack_public_path__ + "media/images/front/brands/creations/card-329f435a6cc0514c545ed78d1474c4f0.webp";